export const absolutePathToSlug = (path) => {
    return path.match(/[^/]*(?=\.md$)/g)[0];
}
